'use client'

import { Checkbox } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputCheckbox: SBDynamicFormInput = ({ item, ...rest }) => {
  return (
    <Checkbox.Group
      {...rest}
      options={item.options?.map((option) => ({
        value: option.id,
        label: option.label,
      }))}
    />
  )
}

export { SBDynamicFormInputCheckbox }
